import React from 'react'
import {ReactComponent as IconoBuscar} from "../../../assets/icons/Buscar.svg"
export const GlobalFilterTable = ({ filter, setFilter }) => {
    // return (
    //     <div className='text-right'>
    //         Buscar en la tabla: {''}
    //         <input className="buscadorTablaHistorial"value ={filter || ''}  onChange={(e) => setFilter(e.target.value)}></input>
    //     </div>
    // )
    return (
        <div className="input-container-buscador">
            <IconoBuscar className="iconoBusqueda"/>
            <input placeholder={"Buscar en tabla"} className="buscadorTablaHistorial" value={filter || ''} onChange={(e) => setFilter(e.target.value)}></input>
        </div>
    )
}
